import { persistedAbilityStateKey } from './state.js';
function assertIdentifier(value, owner) {
    if (!/^[a-z][a-z0-9_]*$/u.test(value)) {
        throw new Error(`${owner} должен соответствовать ^[a-z][a-z0-9_]*$`);
    }
}
function invoke(run, args) {
    if (typeof run === 'function') {
        return run(...args);
    }
    const [ctx, ...rest] = args;
    return run.run(ctx, ...rest);
}
function frequencyAbility(input, kind, slot) {
    assertIdentifier(input.abilityId, `${kind}: abilityId`);
    if (input.legacyKey !== undefined && input.legacyKey.length === 0) {
        throw new Error(`${kind} "${input.abilityId}": legacyKey должен быть непустым`);
    }
    const state = Object.freeze({
        abilityId: input.abilityId,
        kind,
        slot,
        ...(input.legacyKey === undefined ? {} : { legacyKey: input.legacyKey }),
    });
    const dependencies = Object.freeze(typeof input.run === 'function' ? [] : [...input.run.dependencies]);
    return Object.freeze({
        source: 'game_card_ability',
        hook: input.trigger,
        abilityId: input.abilityId,
        dependencies,
        state,
        compile: (cardId) => {
            const key = persistedAbilityStateKey(cardId, state);
            return ((...args) => {
                const ctx = args[0];
                const vars = ctx.self?.vars ?? ctx.effect?.vars ?? ctx.attachment?.vars;
                const alreadyUsed = kind === 'once_per_round'
                    ? vars?.[key] === ctx.round
                    : vars?.[key] === true;
                if (alreadyUsed || !input.when(...args))
                    return undefined;
                ctx.ops.setVar(key, kind === 'once_per_round' ? ctx.round : true);
                return invoke(input.run, args);
            });
        },
    });
}
export function oncePerRound(input) {
    return frequencyAbility(input, 'once_per_round', 'round');
}
export function oncePerInstance(input) {
    return frequencyAbility(input, 'once_per_instance', 'used');
}
//# sourceMappingURL=frequency.js.map